import { a11yProps, sizeTab } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TabOrdenTrabajoNocPendiente from "../../components/TabOrdenTrabajoNocPendiente";
import TabOrdenTrabajoNocRealizadas from "../../components/TabOrdenTrabajoNocRealizadas";

export default function OrdenesNocTecnicoPage() {

    const [valueTab, setValueTab] = useState(0);

    return (
        <>
            <SingleTableBoxScene
                py={2}
                title={"Ordenes de Trabajo NOC"}
                visibleReport={false}
            >
                <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
                    <Tabs
                        value={valueTab}
                        onChange={(_event: React.SyntheticEvent, newValue: number) => {
                            setValueTab(newValue);
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs ordenes trabajo noc"
                    >
                        <Tab label={'Pendientes'} {...a11yProps(0)} />
                        <Tab label={'Realizadas'} {...a11yProps(1)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={valueTab} index={0}>
                    <TabOrdenTrabajoNocPendiente />
                </CustomTabPanel>
                <CustomTabPanel value={valueTab} index={1}>
                    <TabOrdenTrabajoNocRealizadas />
                </CustomTabPanel>
            </SingleTableBoxScene>
        </>
    );

}